<script set lang="ts">
export const elDividerDirection = ['vertical', 'horizontal'] as const;
export type ElDividerDirection = (typeof elDividerDirection)[number];
</script>

<script setup lang="ts">
import { withDefaults } from 'vue';

withDefaults(
  defineProps<{
    direction: ElDividerDirection;
  }>(),
  { direction: 'horizontal' },
);
</script>

<template>
  <div
    class="border rounded-full border-neutral-surface"
    :class="{
      'w-0 h-full': direction === 'vertical',
      'h-0 w-full': direction === 'horizontal',
    }"
  ></div>
</template>
